import { getSelfLinkStr, getNextLinkStr } from '../selectors/bundle';
import { IBundle } from '../modules/unsw-fhir/Bundle';
import {
  IOperationOutcome,
  isOperationOutcome,
} from '../modules/unsw-fhir/OperationOutcome';
import { FhirInstance } from '../config/FhirClient';
import {
  isPractitionerRole,
  IPractitionerRole,
} from '../modules/unsw-fhir/PractitionerRole';

type SearchParams = {
  _count?: string;
  organization?: string;
  practitioner?: string;
};

/// #TODO: Move to a better location
export type ResponsePayload = {
  next?: string;
  data: IPractitionerRole[];
  previous?: string;
};

export const getPractitionerRolesByOrganizationId = async (
  organizationId: string,
  path?: string,
  count?: string,
) => {
  let params: SearchParams | undefined;
  if (!path) {
    params = { organization: organizationId };
    if (count) params._count = count;
  }
  path = !path ? '/PractitionerRole' : path;
  try {
    const response = await FhirInstance.get<IBundle | IOperationOutcome>(path, {
      params,
    });
    const { data } = response;
    if (isOperationOutcome(data) || !data.entry) {
      return { data: [] };
    }

    const retV: ResponsePayload = {
      previous: getSelfLinkStr(data),
      data: [],
      next: getNextLinkStr(data),
    };

    retV.data = data.entry
      .filter(entry => {
        return !!entry.resource && isPractitionerRole(entry.resource);
      })
      .map((entry): IPractitionerRole => entry.resource as IPractitionerRole);

    return retV;
  } catch (e) {
    console.error(e);
    return { data: [] };
  }
};

export const getPractitionerRolesByPractitionerId = async (
  practitionerId: string,
  path?: string,
  count?: string,
) => {
  let params: SearchParams | undefined;
  if (!path) {
    params = { practitioner: practitionerId };
    if (count) params._count = count;
  }
  path = !path ? '/PractitionerRole' : path;
  try {
    const response = await FhirInstance.get<IBundle | IOperationOutcome>(path, {
      params,
    });
    const { data } = response;
    if (isOperationOutcome(data) || !data.entry) {
      return { data: [] };
    }

    const retV: ResponsePayload = {
      previous: getSelfLinkStr(data),
      data: [],
      next: getNextLinkStr(data),
    };

    retV.data = data.entry
      .filter(entry => {
        return !!entry.resource && isPractitionerRole(entry.resource);
      })
      .map((entry): IPractitionerRole => entry.resource as IPractitionerRole);

    return retV;
  } catch (e) {
    console.error(e);
    return { data: [] };
  }
};

export const postPractitionerRole = async (
  practitionerRole: IPractitionerRole,
) => {
  try {
    const response = await FhirInstance.post<
      IPractitionerRole | IOperationOutcome
    >('/PractitionerRole', practitionerRole);
    const { data } = response;
    if (isOperationOutcome(data)) {
      return undefined;
    }
    return data;
  } catch (e) {
    console.error(e);
    return undefined;
  }
};

export const putPractitionerRole = async (
  id: string,
  practitionerRole: IPractitionerRole,
) => {
  try {
    const response = await FhirInstance.put<
      IPractitionerRole | IOperationOutcome
    >(`/PractitionerRole/${id}`, practitionerRole);
    const { data } = response;
    if (isOperationOutcome(data)) {
      return undefined;
    }
    return data;
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
